import React from 'react';
import { Tag } from 'antd';
import { useMaturityMode } from '../hooks/useMaturityMode';

export type MaturityType = 'beta' | 'earlyAccess';

interface MaturityTagProps {
    type: MaturityType;
    style?: React.CSSProperties;
}

export const MaturityTag: React.FC<MaturityTagProps> = ({ type, style }) => {
    const { isBetaMode, isEarlyAccessMode } = useMaturityMode();

    if (type === 'beta' && !isBetaMode) return null;
    if (type === 'earlyAccess' && !isEarlyAccessMode) return null;

    const config = type === 'beta'
        ? { color: 'purple' as const, label: 'BETA' }
        : { label: 'EARLY ACCESS' };

    const tagStyle: React.CSSProperties = type === 'earlyAccess'
        ? { marginLeft: 8, verticalAlign: 'middle', fontSize: 12, color: '#389e0d', background: '#f6ffed', border: '1px solid #b7eb8f', ...style }
        : { marginLeft: 8, verticalAlign: 'middle', fontSize: 12, ...style };

    return (
        <Tag color={type === 'beta' ? 'purple' : undefined} style={tagStyle}>
            {config.label}
        </Tag>
    );
};

/** Inline tag for use in menu items (smaller styling) */
export const MaturityMenuTag: React.FC<{ type: MaturityType }> = ({ type }) => {
    const label = type === 'beta' ? 'BETA' : 'EA';

    const tagStyle: React.CSSProperties = type === 'earlyAccess'
        ? { marginLeft: 4, fontSize: 9, lineHeight: '14px', padding: '0 3px', color: '#389e0d', background: '#f6ffed', border: '1px solid #b7eb8f', flexShrink: 0 }
        : { marginLeft: 4, fontSize: 9, lineHeight: '14px', padding: '0 3px', flexShrink: 0 };

    return (
        <Tag color={type === 'beta' ? 'purple' : undefined} style={tagStyle}>
            {label}
        </Tag>
    );
};
